var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "separator__container", class: _vm.paddingStyle },
    [
      _c("p", { staticClass: "separator__title", class: _vm.textCenterStyle }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }